import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";
import ChangeLanguageButtonComponent from "./change-language-button-component";
import CurrencyNavbarComponent from "./currency-navbar-component";
import NavbarSignInButtonComponent from "./landing-sign-in-button-component";
import MenuOfNavbarComponent from "./menu-of-navbar-component";
import UserAccountDropdownComponent from "./user-account-dropdown-component";

interface IProps {
  showLogo?: boolean;
  logoStyle?: string;
}
function NavbarComponent({ showLogo, logoStyle }: IProps) {
  const [navOnScrollStyle, setNavOnScrollStyle] = useState<boolean>(false);
  const { i18n } = useTranslation();
  const changeNavStyle = () => {
    window.scrollY >= 50
      ? setNavOnScrollStyle(true)
      : setNavOnScrollStyle(false);
  };
  useEffect(() => {
    window.addEventListener("scroll", changeNavStyle);
    return () => {
      window.removeEventListener("scroll", changeNavStyle);
    };
  }, []);
  const navigate = useNavigate();
  const roleValue = localStorage.getItem("role");

  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className={`${
        navOnScrollStyle
          ? "fixed flex w-screen justify-center mobile:top-0 mobile:pt-1.5 animate-fade-up animate-once animate-duration-[800ms] animate-delay-200 animate-ease-out"
          : "absolute mobile:top-3.5 animate-fade-down animate-once animate-duration-[800ms] delay-200 animate-ease-in-out"
      } top-0 z-50`}
    >
      <div
        className={`${
          navOnScrollStyle
            ? "bg-zinc50 w-[calc(100vw-32px)] p-2.5 rounded-xl drop-shadow-[0_0px_20px_rgba(0,0,0,0.1)] mobile:w-[calc(100vw-10px)] mobile:px-1 mobile:py-1.5"
            : "w-screen px-8 mobile:px-2.5"
        } flex flex-row justify-between items-center mt-6 mobile:mt-0`}
      >
        <div className="flex">
          {!navOnScrollStyle && logoStyle === "white" ? (
            <img
              onClick={() => navigate(appRoutesObj.getBasePath())}
              alt=""
              src="/assets/images/alfredo-logo-white.svg"
              className={`${
                showLogo ? "" : "hidden"
              } flex h-8 mobile:h-6 cursor-pointer`}
            />
          ) : (
            <img
              onClick={() => navigate(appRoutesObj.getBasePath())}
              alt=""
              src="/assets/images/logo.svg"
              className={`${
                showLogo ? "" : "hidden"
              } flex h-8 mobile:h-6 cursor-pointer`}
            />
          )}
        </div>
        <div className="flex flex-row gap-4 items-center">
          <ChangeLanguageButtonComponent />
          <CurrencyNavbarComponent />
          {roleValue !== "student" && roleValue !== "school" ? (
            <NavbarSignInButtonComponent />
          ) : (
            <UserAccountDropdownComponent />
          )}
          <MenuOfNavbarComponent navOnScrollStyleValue={navOnScrollStyle} />
        </div>
      </div>
    </div>
  );
}

export default NavbarComponent;
